<template>
  <top-nav />
  <div class="mx-auto w-screen px-4 sm:px-6 lg:px-8">
    <div class="my-14">
      <!-- Analytics -->
      <div class="my-5 font-extrabold">{{ dateString(latest.createdAt.seconds) }}</div>
      <div class="flex space-x-5 overflow-auto text-gray-900 dark:text-white sm:justify-between">
        <template v-for="cohort in Object.entries(latest.cohorts)" :key="cohort">
          <div class="block">
            <div class="flex-0 my-5 mb-3 w-full border-b font-extrabold">L{{ Object.keys(cohort[1])[0] }}</div>
            <div class="block space-y-2">
              <template v-for="metric in Object.values(cohort[1])" :key="metric">
                <template v-for="[key, value] in Object.entries(metric).sort()" :key="key">
                  <div class="item-center flex w-full justify-between space-x-3 text-sm">
                    <div class="">{{ key }}</div>
                    <div class="justify-end">{{ value }}</div>
                  </div>
                </template>
              </template>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import firebaseUser from "../composables/userAuth";
import { db } from "../firebase";
import TopNav from "../components/nav/TopNav.vue";

import utilFunctions from "../composables/util";
import { collection, query, orderBy, getDocs, limit } from "firebase/firestore";
import { ref, watchEffect } from "vue";
// import { mergeWith, isNumber, every } from "lodash";

export default {
  components: {
    TopNav,
  },
  setup() {
    const { user } = firebaseUser();
    const { getUser, dateString } = utilFunctions();
    const userData = ref({});
    // const cohorts = ref([]);
    // const cohortTimeFrames = [1, 7, 28, 90];

    // function percDifferences(yesterday, today) {
    //   const diff = (today - yesterday) / yesterday;
    //   return Math.round(diff).toFixed(1) + "%";
    // }
    const latest = ref([]);
    watchEffect(async () => {
      if (user.value) {
        userData.value = await getUser(user.value.uid);

        

        if ("roles" in userData.value && userData.value.roles?.reviewer) {
          const q = query(collection(db, "analytics"), orderBy("createdAt", "desc"), limit(1));

          const querySnapshot = await getDocs(q);
          latest.value = querySnapshot.docs[0].data();

          // for (let i = 0; i < cohortTimeFrames.length; i++) {
          //   // console.log(latestCohortData)
          //   // console.log(cohort)
          //   latest.value.push(latestCohortData[i]);

          //   // get keys
          //   const keys = Object.keys(latestCohortData[i]);
          //   console.log(keys)
          // }
          // loop through cohortTimeFrames
          // cohortTimeFrames.forEach((cohort) => {
          //   const cohortNumber = cohort - 1;

          //   if(!querySnapshot.docs[cohortNumber].data().cohorts) return

          // const current = querySnapshot.docs[cohortNumber].data().cohorts ?? null;
          // const previous = querySnapshot.docs[cohortNumber + cohortNumber].data().cohorts ?? null;

          // const change = mergeWith(querySnapshot.docs[cohortNumber].data().cohorts, querySnapshot.docs[cohortNumber - cohortNumber].data().cohorts, (a, b) => {
          //   if (every([a, b], isNumber)) return a - b;
          // });

          //   cohorts.value.push({
          //     [cohortNumber + 1]: {
          //       current: querySnapshot.docs[cohortNumber].data().cohorts ?? null,
          //       previous: querySnapshot.docs[cohortNumber + cohortNumber].data().cohorts ?? null,
          //       // change,
          //     },
          //   });
          // });
        }
      }
    });

    return {
      user,
      latest,
      dateString,
    };
  },
};
</script>
